import * as React from "react"
import { connect } from "react-redux"
import trans from "trans"

import {
    Grid,
    GridCell,
    Select,
    FieldLabel,
    Icon,
    Autocomplete,
    css,
    InputGroup,
    Theme,
} from "@bdfx/mergado-ui-kit"

import {
    updateInputValue,
} from "app/reducers/form";
import { StyledSliderDiv } from "./filters";
import { Slider } from "@mui/material";
import { ReduxList } from "app/types/app-types";
import { AvailableOptionsType } from "../types";
import { FiltersFormType } from "../types/filtertypes";
import { getBgColorsLike, isGodModeOn } from "app/helpers/api";
import { AxiosResponse } from "axios";
import { selectFormValues } from "app/reducers/form";
import { allowSuperadminForUsers } from "template-edit/components/helper";
import { StyledInputGroupFilter } from "shape-edit/forms/fields";
import { isValidHEXColor } from "shape-edit/forms/palette-colors";

interface Props {
    userId: number
    setIsDirty: Function
    updateInputValue: typeof updateInputValue
    availableOptions: ReduxList<AvailableOptionsType>
    filtersForm: FiltersFormType
}

interface State {
    bgColorSearchString: string
    bgColorValues: string[]
}

class BackgroundFilters extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            bgColorSearchString: '',
            bgColorValues: [],
        }
    }

    handleChangeAutocompleteString = (value: string) => {
        const bgColorSearchString = value && typeof value[0] !== 'undefined' && value[0]==='#' ? value : `#${value}`

        this.setState({ bgColorSearchString: bgColorSearchString })
        getBgColorsLike(bgColorSearchString)
            .then((response: AxiosResponse<any>) => {
                this.setState({ bgColorValues: response.data.match })
            })
            .catch((error) => {
                console.error('autocomplete error', error.response)
            })

        if (isValidHEXColor(bgColorSearchString)) {
            this.props.updateInputValue('filtersForm', 'image.bg_color', [bgColorSearchString]);
            this.props.setIsDirty(true)
        }
    }

    render() {
        const { availableOptions, filtersForm, userId } = this.props
        const { bgColorValues, bgColorSearchString } = this.state

        const availableMergedBackgroundColors = availableOptions.data && availableOptions.data.merged_background_colors ?
            availableOptions.data.merged_background_colors.map((o: string) => {
                const color = `${o}`
                return {
                    label: color,
                    value: color,
                    text: <React.Fragment><Icon type={'circle'} color={color} /> <span>{color}</span></React.Fragment>

                }
            }) : null

        const isAllowSpecialFields = (allowSuperadminForUsers.includes(userId) || isGodModeOn)

        return (
            <>
                <GridCell className={filtersForm.image.is_light_bg !== null ? "active-filter" : ''}>
                    <StyledInputGroupFilter
                        formName='filtersForm.image.is_light_bg'
                        singleChoice={true}
                        onChange={() => this.props.setIsDirty(true)}
                        transString={'background_shade'}
                        iconType={'inner-shadow-radix'}
                        showClear={filtersForm.image.is_light_bg}
                        items={[
                            { label: trans('light_bg'), value: '1' },
                            { label: trans('dark_bg'), value: '0' },
                        ]}
                        onClear={() => {
                            this.props.updateInputValue('filtersForm', 'image.is_light_bg', null)
                            this.props.setIsDirty(true)
                        }}
                    />


                </GridCell>

                <GridCell className={filtersForm.image.is_solid_bg !== null ? "active-filter" : ''}>
                    <StyledInputGroupFilter
                        formName='filtersForm.image.is_solid_bg'
                        singleChoice={true}
                        onChange={() => this.props.setIsDirty(true)}
                        transString={'background_colors'}
                        iconType={'color-wheel-radix'}
                        showClear={filtersForm.image.is_solid_bg}
                        items={[
                            { label: trans('solid_bg'), value: '1' },
                            { label: trans('multicolor_bg'), value: '0' },
                        ]}
                        onClear={() => {
                            this.props.updateInputValue('filtersForm', 'image.is_solid_bg', null)
                            this.props.setIsDirty(true)
                        }}
                    />
                </GridCell>

                {isAllowSpecialFields &&
                    <GridCell className={'some-users-only'}>
                        <StyledInputGroupFilter
                            formName='filtersForm.image.is_transparent'
                            singleChoice={true}
                            onChange={() => this.props.setIsDirty(true)}
                            transString={'has_alpha'}
                            iconType={'transparency-grid-radix'}
                            showClear={filtersForm.image.is_transparent}
                            items={[
                                { label: trans('transparent_bg'), value: '1' },
                                { label: trans('not_transparent_bg'), value: '0' },
                            ]}
                            onClear={() => {
                                this.props.updateInputValue('filtersForm', 'image.is_transparent', null)
                                this.props.setIsDirty(true)
                            }}
                        />
                    </GridCell>
                }

                <GridCell style={{ padding: '0 8px' }} className={bgColorSearchString ? "active-filter" : ''}>
                    <Autocomplete
                        value={bgColorSearchString}
                        label={trans('background_color')}
                        items={bgColorValues.map((o) => {
                            return {
                                label: o,
                                text: <Icon type={'circle'} text={o} color={o} className={'autocomplete-icon-text'} />,
                                value: `${o}`
                            }
                        })}
                        onClear={() => this.setState({bgColorSearchString: null})}
                        onChange={this.handleChangeAutocompleteString}
                    />

                    {availableMergedBackgroundColors &&
                        <StyledColorsGrid>
                            {availableMergedBackgroundColors.map((item, key) => {
                                const isActive = filtersForm.image?.bg_color?.includes(item.value)
                                return <GridCell
                                    key={`bgcolor_${key}`}
                                    title={item.value}
                                    className={`clickable shadow-box ${isActive ? 'active-color' : ''}`}
                                    style={{
                                        background: item.value,
                                    }}
                                    onClick={() => {
                                        let newBgColors = []
                                        if (isActive) {
                                            filtersForm.image.bg_color.forEach(c => {
                                                if (c !== item.value) {
                                                    newBgColors.push(c)
                                                }
                                            })
                                        } else {
                                            newBgColors = filtersForm.image.bg_color && Array.isArray(filtersForm.image.bg_color) ? [...filtersForm.image.bg_color, item.value] : [item.value]
                                        }

                                        this.props.updateInputValue('filtersForm.image', 'bg_color', newBgColors)
                                        this.props.setIsDirty(true)

                                        this.setState({ bgColorSearchString: item.value })
                                    }}
                                />
                            })}
                        </StyledColorsGrid>
                    }
                </GridCell>

                {filtersForm.image.bg_color && Array.isArray(filtersForm.image.bg_color) && filtersForm.image.bg_color.length > 0 &&
                    <GridCell style={{ alignSelf: 'end', padding: '0 8px' }}>
                        <FieldLabel>{trans('bg_color_distance')}</FieldLabel>
                        <StyledSliderDiv>
                            <Slider
                                value={filtersForm.image.bg_color_distance ? parseInt(`${filtersForm.image.bg_color_distance}`) : 10}
                                onChange={(event: Event, value: number) => {
                                    this.props.updateInputValue('filtersForm', 'image.bg_color_distance', value)
                                    this.props.setIsDirty(true)
                                }}
                                step={5}
                                min={0}
                                max={100}
                                color={filtersForm.image.bg_color && filtersForm.image.bg_color.length > 0 && filtersForm.image.bg_color_distance ? 'primary' : 'secondary'}
                                marks={[{ value: 0, label: trans('small_distance') }, { value: 20 }, { value: 30, label: trans('medium_distance') }, { value: 40 }, { value: 100, label: trans('big_distance') }]}
                                valueLabelDisplay="auto"
                                getAriaLabel={() => `${trans('bg_color_distance')}`}
                                getAriaValueText={(value) => `${value}`}
                                valueLabelFormat={(value) => `${value}`}
                            />
                        </StyledSliderDiv>
                    </GridCell>
                }
            </>
        )
    }
}

const StyledColorsGrid = css(Grid)({
    marginLeft: '-16px',
    padding: '8px',
    gridTemplateColumns: 'repeat(10, auto)',
    gridTemplateRows: '16px 16px',
    gridGap: '5px',
    ' .muk-gridcell': {
        borderRadius: '50%',
        overflow: 'hidden',
        color: 'transparent',
    },
    ' .active-color': {
        boxShadow: `0 0 4px 2px ${Theme.steelblue}`,
        webkitBoxShadow: `0 0 4px 2px ${Theme.steelblue}`,
        mozBoxShadow: `0 0 4px 2px ${Theme.steelblue}`,
    },
})

function mapStateToProps(state) {
    return {
        availableOptions: state.availableOptions,
        filtersForm: selectFormValues(state,'filtersForm'),
    }
}

export default connect(mapStateToProps, {
    updateInputValue,
})(BackgroundFilters)
